import React from "react";
import { Avatar, Button, Divider, Typography } from "@material-ui/core";

// Solo lee los datos compartidos; nunca crea contactos ni tickets.
const parseSharedVcards = (raw) => {
  const source = String(raw || "");
  const blocks = source.match(/BEGIN:VCARD[\s\S]*?END:VCARD/gi) || [];

  return blocks.slice(0, 30).map((block, index) => {
    const lines = block.replace(/\r\n/g, "\n").replace(/\n[ \t]/g, "").split("\n");
    let name = "";
    let nameFallback = "";
    const phones = [];

    lines.forEach((line) => {
      const separator = line.indexOf(":");
      if (separator < 0) return;
      const field = line.slice(0, separator);
      const type = field.split(";")[0].toUpperCase();
      const value = line.slice(separator + 1)
        .replace(/\\n/gi, " ").replace(/\\,/g, ",").trim();

      if (type === "FN") name = value;
      if (type === "N") {
        const parts = value.split(";");
        nameFallback = [parts[1], parts[0]].filter(Boolean).join(" ");
      }
      if (type === "TEL") {
        const waid = field.match(/(?:^|;)waid=(\d+)/i);
        const digits = (waid ? waid[1] : value).replace(/\D/g, "");
        if (digits.length >= 8 && digits.length <= 15 && !phones.some((p) => p.digits === digits)) {
          phones.push({ label: value, digits });
        }
      }
    });

    return { id: index, name: name || nameFallback || "Contacto compartido", phones };
  });
};

const VcardPreview = ({ body }) => {
  const contacts = parseSharedVcards(body);
  const agent = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const isAndroid = /Android/i.test(agent);
  const isIOS = /iPhone|iPad|iPod/i.test(agent) ||
    (typeof navigator !== "undefined" && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  return (
    <div style={{ minWidth: 230, maxWidth: 340 }}>
      {contacts.length === 0 && (
        <Typography variant="body2">No se pudieron leer los datos del contacto compartido.</Typography>
      )}
      {contacts.map((contact) => (
        <div key={contact.id} style={{ padding: "10px 0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
            <Avatar>{contact.name.charAt(0).toUpperCase()}</Avatar>
            <Typography variant="subtitle1">{contact.name}</Typography>
          </div>
          {contact.phones.length === 0 && (
            <Typography variant="body2">Sin número telefónico disponible</Typography>
          )}
          {contact.phones.map((phone) => (
            <div key={phone.digits} style={{ paddingBottom: 8 }}>
              <Typography variant="body2">{phone.label}</Typography>
              {isAndroid ? (
                <Button
                  component="a"
                  fullWidth
                  variant="outlined"
                  color="primary"
                  size="small"
                  href={`intent://send?phone=${phone.digits}#Intent;scheme=whatsapp;package=com.whatsapp.w4b;end`}
                  style={{ textTransform: "none", marginTop: 5 }}
                >
                  Abrir en WhatsApp Business
                </Button>
              ) : isIOS ? (
                <Button
                  component="a"
                  fullWidth
                  variant="outlined"
                  color="primary"
                  size="small"
                  href={`whatsapp-business://send?phone=${phone.digits}`}
                  style={{ textTransform: "none", marginTop: 5 }}
                >
                  Abrir en WhatsApp Business
                </Button>
              ) : (
                <Typography variant="caption" color="textSecondary">
                  Abre esta tarjeta desde Android o iPhone para intentar iniciar un chat en WhatsApp Business.
                </Typography>
              )}
            </div>
          ))}
          <Divider />
        </div>
      ))}
    </div>
  );
};

export default VcardPreview;
